module.exports = __webpack_public_path__ + "img/device-basic.6eb0fcea.jpg";